import * as React from "react";
import type { SVGProps } from "react";
const SvgOneWaySign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.5 8.6c0-.63.74-.98 1.23-.57l4.08 3.4c.36.3.36.85 0 1.15l-4.08 3.4a.75.75 0 0 1-1.23-.58v-1.9H6.75a.75.75 0 0 1-.75-.75v-1.5c0-.41.34-.75.75-.75h5.75z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 4a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zM6 6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOneWaySign;
